/* eslint-disable react/prefer-stateless-function,null,react/no-unused-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  initState,
  selectData,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/data/reducer';
import { t } from 'utils/translates';

const privateRoomRN = 'messengerModule.objects.privateRoom';

class PrivateMessageButton extends Component {
  componentDidMount() {
    this.props.initState();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectData !== prevProps.selectData &&
      this.props.selectData.roomUuid
    ) {
      this.props.history.push(
        `/main/messenger/room/${this.props.selectData.roomUuid}`
      );
    }
  }

  getPrivateRoom = () => {
    this.props.sendRequest();
  };

  render() {
    const { requestState } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <button
          className="btn btn-default"
          data-toggle="modal"
          type="button"
          disabled={requestState.inProgress}
          onClick={this.getPrivateRoom}
        >
          {requestState.inProgress ? (
            <i className="fa fa-circle-o-notch fa-spin" />
          ) : (
            <i className="fa fa-comments-o" />
          )}{' '}
          {t('Написать личное сообщение')}
        </button>
      </div>
    );
  }
}

PrivateMessageButton.defaultProps = {
  selectData: null
};
PrivateMessageButton.propTypes = {
  userId: PropTypes.number.isRequired,

  history: PropTypes.shape().isRequired,

  // CONNECT
  initState: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  selectData: PropTypes.shape({
    roomUuid: PropTypes.string
  }),
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, privateRoomRN),
  selectData: selectData(state, privateRoomRN)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(privateRoomRN)),
  sendRequest: () => dispatch(sendRequest(privateRoomRN, props.userId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PrivateMessageButton)
);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/PrivateMessageButton/PrivateMessageButton.js